//import BizReviewSettings from "../../models/BizReviewSettings";
import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async getRedirectLink(context, args) {
      try {
        const customerId = args.customerId;
        let response = await axios({
          method: "get",
          url: `${API_BASE_URL}/redirect-link?type=review${
            customerId ? "&customerId=" + customerId : ""
          }`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          }
        });
        this.dispatch("entities/settings/setIsOffline", false);
        return response.data;
      } catch (error) {
        this.dispatch("entities/settings/setIsOffline", true);
      }
    }
  }
};
